export default {
  methods: {
    /**
     * 分析条件の復元が完了したときに行う処理
     * Mixinにはデフォルト実装を置くので、本実装は各コンポーネント側で行う
     */
    onQueryFilterRestoreCompleted() {},
  },
  watch: {
    // 分析条件の復元が完了した通知を受け取る
    _queryFilterRestoring(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.onQueryFilterRestoreCompleted()
      }
    },
  },
  computed: {
    // 分析条件の復元状況
    _queryFilterRestoring() {
      return this.$store.state.queryFilterRestoring
    },
  },
}
